"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LaundrySVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M16 26a7 7 0 01-6.94-6.13A6.36 6.36 0 019 19v-.44c1.14-1.08 3.3-2 7 .44s5.84 1.52 7 .44A7 7 0 0116 26z"/><path d="M26 2H6a3 3 0 00-3 3v23a2 2 0 002 2h22a2 2 0 002-2V5a3 3 0 00-3-3zM8 6h4a1 1 0 010 2H8a1 1 0 010-2zm8 22a9 9 0 119-9 9 9 0 01-9 9z"/>';
var LaundrySVG = function LaundrySVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.LaundrySVG = LaundrySVG;
LaundrySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LaundrySVG);
exports.default = _default;